import { TRACKING_ENUMS, trackEvent } from 'Utils/Analytics';
import {
  CL_PREAUTH_GIFTING_PARAM,
  CL_PREAUTH_ROUTER_STATE_PARAM,
  CL_PREAUTH_SECOND_SCREEN_PARAM,
  CL_PREAUTH_URL_SEARCH_PARAM,
} from 'Utils/Constants';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from 'Hooks/useStore';
import { setSecondScreen } from 'State/SecondScreen';
import { callCentralAuthLogin } from 'Utils/CentralizedLoginSDK';
import { Loader } from 'Components/Loader';
import { useAddPreAuthParams } from 'Hooks/useAddPreAuthParams';

export function SignInContainer() {
  const { routes } = useStore('appConfig');
  const location = useLocation();
  const { pathname = '' } = location;
  const urlParams = new URLSearchParams(location.search);
  const { isGifting } = useStore('purchaseMode');
  const user = useStore('user');

  const isDeviceActivation = pathname.includes('tv');

  const navigate = useNavigate();

  const addPreAuthParams = useAddPreAuthParams();

  useEffect(() => {
    trackEvent(
      TRACKING_ENUMS.EVENT_LOGIN_STARTED,
      { setPageName: 'profile_sign_in_landing' },
      { dcg_profile_id: user.profileId }
    );

    let secondScreen = {};
    if (isDeviceActivation) {
      const code = urlParams.get('code');
      const device = urlParams.get('device');
      secondScreen = {
        isDeviceActivation,
        code,
        device,
      };
      setSecondScreen(secondScreen);

      if (user.isAuthenticated) {
        navigate(routes.callback);

        return;
      }
    }
    // centralized auth route
    // store the current url params before redirecting to centralized login so we can retrieve them later
    const stateUuid = addPreAuthParams({
      ...(urlParams ? { [CL_PREAUTH_URL_SEARCH_PARAM]: Object.fromEntries(urlParams) } : {}),
      ...(isDeviceActivation ? { [CL_PREAUTH_SECOND_SCREEN_PARAM]: secondScreen } : {}),
      ...(isGifting ? { [CL_PREAUTH_GIFTING_PARAM]: true } : {}),
      ...(location.state
        ? (() => {
            try {
              return { [CL_PREAUTH_ROUTER_STATE_PARAM]: JSON.stringify(location.state) };
            } catch (e) {
              console.warn('Error trying to serialize location.state', e);
              return {};
            }
          })()
        : {}),
    });

    // call centralized login which if successful will redirect the user to /callback
    void callCentralAuthLogin({
      state: stateUuid,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader />;
}
